import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Enhanced global error handler for dynamic import failures
function handleDynamicImportError(error: any): boolean {
  const isDynamicImportError = error && (
    (error.message && error.message.includes('Loading chunk')) ||
    (error.message && error.message.includes('Failed to fetch dynamically imported module')) ||
    (error.message && error.message.includes('ChunkLoadError'))
  );

  if (isDynamicImportError) {
    console.warn('Dynamic import error detected:', error);
    
    // Show user-friendly message
    const reload = confirm(
      'We detected an issue loading the application. This usually happens after an update. ' +
      'Would you like to reload the page to get the latest version?'
    );
    
    if (reload) {
      // Clear caches and reload
      if ('caches' in window) {
        caches.keys().then(names => {
          Promise.all(names.map(name => caches.delete(name)))
            .then(() => (window as any).location.reload());
        }).catch(() => (window as any).location.reload());
      } else {
        (window as any).location.reload();
      }
    }
    return true;
  }
  return false;
}

// Global error handler
window.addEventListener('error', (event) => {
  if (handleDynamicImportError(event.error)) {
    event.preventDefault();
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (handleDynamicImportError(event.reason)) {
    event.preventDefault();
  }
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    console.error('Application bootstrap failed:', err);
    
    if (handleDynamicImportError(err)) {
      return;
    }
    
    // Show generic error message for other bootstrap failures
    document.body.innerHTML = `
      <div style="
        display: flex; 
        align-items: center; 
        justify-content: center; 
        min-height: 100vh; 
        font-family: Arial, sans-serif;
        background: #f5f5f5;
        margin: 0;
        padding: 20px;
      ">
        <div style="
          background: white; 
          padding: 40px; 
          border-radius: 8px; 
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          text-align: center;
          max-width: 400px;
        ">
          <h2 style="color: #d32f2f; margin-bottom: 16px;">Application Error</h2>
          <p style="color: #666; margin-bottom: 24px;">
            The application failed to start. Please refresh the page or try again later.
          </p>
          <button onclick="window.location.reload()" style="
            background: #1976d2; 
            color: white; 
            border: none; 
            padding: 12px 24px; 
            border-radius: 4px; 
            cursor: pointer;
            font-size: 14px;
          ">
            Reload Page
          </button>
        </div>
      </div>
    `;
  });
